import { GatewayType, Salutation, TransferInstallationAddress } from '@vi-iot/client';

export enum GATEWAY_COMMISSIONING_STEP {
  SELECT_INSTALLATION_TYPE = 'SELECT_INSTALLATION_TYPE',
  PROVIDE_TRANSFER_DATA = 'PROVIDE_TRANSFER_DATA',
  INSTRUCTIONS = 'INSTRUCTIONS',
  CHECK_LIGHT = 'CHECK_LIGHT',
  TRANSFER_INSTALLATION = 'TRANSFER_INSTALLATION',
  TRANSFER_INSTALLATION_SUCCESS = 'TRANSFER_INSTALLATION_SUCCESS',
  TRANSFER_OMA_INSTALLATION_SUCCESS = 'TRANSFER_OMA_INSTALLATION_SUCCESS',
  TRANSFER_COMMERCIAL_INSTALLATION_SUCCESS = 'TRANSFER_COMMERCIAL_INSTALLATION_SUCCESS',
}

export enum GATEWAY_COMMISSIONING_DEVICE {
  NONE = 'NONE',
  VITOCONNECT = 'VITOCONNECT',
  ONE_BASE = 'ONE_BASE',
}

export enum GATEWAY_COMMISSIONING_FLOW {
  RESIDENTIAL = 'RESIDENTIAL',
  COMMERCIAL = 'COMMERCIAL',
}

export enum HeatingType {
  None = 'None',
  FloorHeating = 'Floor Heating',
  Radiators = 'Radiators',
  Both = 'Both',
  Undefined = 'Undefined',
}

export enum GatewayStateEnum {
  Produced = 'produced',
  Registered = 'registered',
}

export interface GatewayData {
  serial: string;
  password: string;
}

export interface TransferInstallationFormData {
  address?: TransferInstallationAddress;
  description?: string;
  email?: string;
  gateway?: GatewayData;
  heatingType?: HeatingType;
  installationOwnerData?: InstallationOwnerData;
  isGrandmaFunctionSelected?: boolean;
  isOwnerOfTheInstallationSelected?: boolean;
  withoutOwner?: boolean;
}

export interface InstallationOwnerData {
  salutation: Salutation;
  firstName: string;
  lastName: string;
  privacyPolicyAccepted: boolean;
  privacyPolicyAcceptanceUtc: string;
}

export interface GatewayCommissioningAvailability {
  isLoading: boolean;
  isAvailable: boolean;
}

export enum COMMISSIONING_TABS {
  TYPE = '0',
  CONNECT = '1',
  VALIDATE = '2',
  TRANSFER = '3',
}

export interface VerifyGatewayResponse {
  verificationSuccessfull: boolean;
  gatewayState: GatewayStateEnum;
  hasMaintainer: boolean;
  isOnline: boolean;
  gatewayType: GatewayType;
  rescueUpdateOngoing: boolean;
  lanActive: boolean;
  tags: string[];
}
